/* eslint-disable */
import 'extlibs/aw2-1.0';
import ajax from 'modules/global/ajax';
import FormValidator from 'modules/FormValidator';
import Messaging from 'modules/Messaging';

export default class ForgottenPassword {
	constructor( loginForm ) {
		this.loginForm = loginForm;
		this.forgotHandle = document.querySelector( '#forgot-password' );

		if ( this.forgotHandle ) {
			this.usernameInput = document.querySelector( '[name="_key"]' );
			this.usernameInputlabel = this.usernameInput.parentNode;
			this.usernamePlaceholder = this.usernameInput.getAttribute( 'placeholder' );
			this.loginHandle = document.querySelector( '#back-to-login' );
			this.loginHandleReset = document.querySelector( '#back-to-reset' );
			this.iconElement = this.usernameInput.previousElementSibling;
			this.usernameIcon = 'person';
			this.forgottenIcon = 'email';

			this.validator = new FormValidator;
			this.messages = new Messaging;
			this.bindings();
			if(window.location.href.indexOf('?reset=true') != -1){
				this.showForm(undefined,true);
			}
		}
	}

	bindings() {
		this.forgotHandle.addEventListener( 'click', this.showForm.bind( this ) );
		this.loginHandle.addEventListener( 'click', this.hideForm.bind( this ) );
		this.loginHandleReset.addEventListener( 'click', this.showResetMsgForm.bind( this ) );
	}

	showForm( _e ,skip) {
		if ( typeof _e !== 'undefined' ) {
			_e.preventDefault();
		}

		this.forgotHandle.classList.add( 'hide' );
		this.loginHandle.classList.remove( 'hide' );

		// Bind form event listener
		this.loginForm.unbind();
		$aw2.bind( 'submit.forgottenPassword', 'form', this.resetPassword.bind( this ) );

		this.hidePasswordField();

		let submitButton = document.querySelector( '#login-button button' );
		let loginText = submitButton.querySelector( '.login-text' );
		let resetText = submitButton.querySelector( '.reset-text' );
		document.querySelector( '#lblp1' ).classList.remove('hide');
		document.querySelector( '#lblp2' ).classList.remove('hide');
		if(skip){
		document.querySelector( '#lblp2' ).textContent = "The reset link has expired. Please reenter your User email address."
		}
		else document.querySelector( '#lblp2' ).textContent = "Enter the email address for your WasteHarmonics account & we'll email you a link to reset your password."
		submitButton.classList.add('reset-button');
		//submitButton.classList.add('blue');
		this.usernameInput.setAttribute( 'placeholder', 'Enter email address' );
		this.iconElement.textContent = this.forgottenIcon;
        if(!skip){
			loginText.classList.remove( 'active' );
			resetText.classList.add( 'active' );
		}
		loginText.classList.add( 'hide' );
		resetText.classList.remove( 'active' );
	}

	showResetMsgForm(){
		this.hideForm();
		document.querySelector( '#login' ).classList.add('hide');
		document.querySelector( '#lblp3' ).textContent = document.querySelector( '#lblp3' ).textContent.replace('##email##',this.usernameInput.value);
		document.querySelector( '#reset-msg' ).classList.remove('hide');
	}

	hideResetMsgForm(){
		this.hideForm();
		document.querySelector( '#login' ).classList.remove('hide');
		document.querySelector( '#reset-msg' ).classList.add('hide');
	}

	hideForm( _e ) {
		if ( typeof _e !== 'undefined' ) {
			_e.preventDefault();
		}

		this.loginHandle.classList.add( 'hide' );
		this.forgotHandle.classList.remove( 'hide' );

		$aw2.unbind( '.forgottenPassword' );
		this.loginForm.bindings();

		this.showPasswordField();

		let submitButton = document.querySelector( '#login-button button' );
		let loginText = submitButton.querySelector( '.login-text' );
		let resetText = submitButton.querySelector( '.reset-text' );
		document.querySelector( '#lblp1' ).classList.add('hide');
		document.querySelector( '#lblp2' ).classList.add('hide');
		submitButton.classList.remove('reset-button');
		//submitButton.classList.add('orange');
		this.usernameInput.setAttribute( 'placeholder', this.usernamePlaceholder );
		this.usernameInputlabel.classList.remove( 'error' );
		this.iconElement.textContent = this.usernameIcon;

		loginText.classList.remove( 'active' );
		resetText.classList.remove( 'active' );

		loginText.classList.remove( 'hide' );
		//resetText.classList.add( 'active' );

	}

	hidePasswordField() {
		let $passwordFieldInput = $( '#_secret' );
		$passwordFieldInput.prop( 'required', false );
		let $passwordField = $passwordFieldInput.closest( '.control' );
		$passwordField.slideUp();
	}

	showPasswordField() {
		let $passwordFieldInput = $( '#_secret' );
		$passwordFieldInput.prop( 'required', true );
		let $passwordField = $passwordFieldInput.closest( '.control' );
		$passwordField.removeClass( 'hide' );
		$passwordField.slideDown();
	}

	resetPassword( _e ) {
		_e.preventDefault();

		let email = this.usernameInput.value;
		let validEmail = this.validator.validateEmail( email );

		this.usernameInputlabel.classList.remove( 'error' );

		if ( !validEmail ) {
			this.usernameInputlabel.classList.add( 'error' );

			this.messages.error( 'Please enter a valid email' );

			return false;
		}

		let call = ajax.put( '/user/forgot-password', {
			email: email
		} );

		$.when( call )
			.done( ( _response ) => {
				this.messages.success( _response.api.body );
				this.showResetMsgForm();
				//this.hideForm();
			} )
			.fail( ( _response ) => {
				this.messages.error( _response.message );
				if(_response.statuscode != '808'){
					this.showResetMsgForm();
				}
			} );
	}
}



// WEBPACK FOOTER //
// ./src/js/modules/forms/ForgottenPassword.js